export const ICON_TYPE_EDITOR = 'editor';
export const ICON_TYPE_GALLERY = 'gallery';
export const ICON_TYPE_ABOUT = 'about';
export const ICON_TYPE_SEARCH = 'search';
export const ICON_TYPE_IFRAME = 'iframe';
export const ICON_TYPE_SHARE = 'share';
export const ICON_TYPE_PROJECTS = 'projects';
export const ICON_TYPE_BIN = 'bin';
